import { useContext } from "react";
import { CMSContext } from "../State";

function useCMS() {
  const data = useContext(CMSContext);

  return data;
}

export default useCMS;
